var _style, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiamondHistory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 576 466.76",
    style: {
      enableBackground: "new 0 0 576 466.76"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#9B9B9B;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M569.36,121.71L501.63,18.87C493.76,7.02,480.46-0.07,466.24,0H109.79c-14.37,0-27.58,7.05-35.4,18.87 L6.66,121.72c-10,15.27-8.62,35.33,3.38,49.09l245.93,281.53c8.1,9.2,19.78,14.46,32.04,14.43c12.26,0.03,23.93-5.24,32.02-14.44 L565.99,170.8C577.96,157.03,579.34,136.98,569.36,121.71z M537.45,152.58L296.19,428.74c-2.8,3.21-6.33,3.68-8.19,3.68 s-5.4-0.5-8.2-3.68L38.58,152.58c-3.09-3.5-3.44-8.65-0.86-12.54l66.39-100.86c2.01-3.04,5.4-4.88,9.08-4.88h349.61 c3.69,0,7.05,1.81,9.04,4.85l66.44,100.86C540.87,143.92,540.49,149.07,537.45,152.58z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamondHistory);
export default __webpack_public_path__ + "static/media/diamond-history.d776c0ae.svg";
export { ForwardRef as ReactComponent };